module.exports = __webpack_public_path__ + "static/008179-f3f826ce43dbe2b76c1176ec455a887e.jpg";